import {createFileRoute} from '@tanstack/react-router';
import ClubTeamsPage from '../../../../players/ClubTeamsPage.tsx';

export const Route = createFileRoute('/_app/cricket/teams/')({
    component: () => <ClubTeamsPage sport="cricket" />,
});
